export default __webpack_public_path__ + "static/media/nft_image_7.f86b2e6a.png";